import React, { useCallback, useEffect, useState } from "react";
import PageContainer from "../components/PageContainer";
import { infographics_mockup } from "./Infographics";
import Pagination from "../components/Pagination";
import { getDocsBook } from "../api/document";
import ImageWithTooltip from "../components/ImageWithTooltip";
import { toImagePath } from "../utils/globalFunctions";
import { useNavigate } from "react-router-dom";

const NCSABook = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);

  const [pageData, setPageData] = useState([]);

  const pageStart = currentPage * 12;
  const pageEnd = pageStart + 12;

  const getData = useCallback(
    () =>
      getDocsBook()
        .then((res) => setPageData(res.docsset))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const displayShelf = (
    <div className="max-w-[900px] h-[800px]  mx-auto pt-[200px]  absolute top-0 left-0 right-0">
      <img
        src="/images/docs/shelf.png"
        alt="shelf"
        style={{
          width: "100%",
          height: "100px",
          marginBottom: "150px",
        }}
      />

      <img
        src="/images/docs/shelf.png"
        alt="shelf"
        style={{
          width: "100%",
          height: "100px",
          marginBottom: "150px",
        }}
      />
      <img
        src="/images/docs/shelf.png"
        alt="shelf"
        style={{
          width: "100%",
          height: "100px",
        }}
      />
    </div>
  );

  const displayBooks = (
    <div className="w-screen max-w-[900px] mx-auto">
      <div className="grid md:grid-cols-4 sm:grid-cols-3 grid-cols-2  gap-y-[50px] relative">
        {pageData.slice(pageStart, pageEnd).map((img) => (
          <div
            key={img.cover._id}
            className="relative cursor-pointer"
            onClick={() => navigate(`/ncsa_book/${img.cover._id}`)}
            // onClick={() => window.open(toImagePath(img.pdflink.path), "_blank")}
          >
            <ImageWithTooltip
              src={img.cover.path}
              alt={img.title}
              className="w-[150px] h-[200px] object-cover overflow-hidden rounded-lg place-self-center hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <PageContainer
      title="NCSA Book"
      bgImg="/images/docs/infographic-banner.png"
    >
      <section>
        <div className="bg-[#4E4E4E] py-[100px]">
          <div className=" relative h-[800px] max-w-[900px] mx-auto">
            {displayShelf}
            {displayBooks}
          </div>

          <Pagination
            pageCount={Math.ceil(pageData.length / 12)}
            onPageChange={handlePageChange}
          />
        </div>
      </section>
    </PageContainer>
  );
};

export default NCSABook;
